export default __webpack_public_path__ + "static/media/gamestop.3bdfa6d8.webp";